import React from "react";
import "../Css/Admincontact.css";

const contacts = [
  {
    name: "Vinod Chauhan",
    email: "vchauhan2114@gmail.com",
    phone: "469-422-1503",
    alignment: "items-start text-left",
  },
  {
    name: "Harish Doolabh",
    email: "harrydoolabh@gmail.com",
    phone: "501-940-1576",
    alignment: "items-center text-center",
  },
  {
    name: "Arun Arya",
    email: "arya.arun@gmail.com",
    phone: "714-875-8141",
    alignment: "items-end text-right",
  },
];

const AdminContacts = () => {
  return (
    <div className="w-full flex flex-col items-center py-4 px-5">
      <h1 className="text-3xl font-bold text-[#F5951C] mb-4 admin">
        ADMIN CONTACT
      </h1>
      <div className="w-full max-w-5xl flex justify-between text-center flex-wrap mx-auto gap-5 sm:gap-20 lg:gap-[250px] gap-y-15">
        {contacts.map((contact, index) => (
          <div
            key={index}
            className={`flex flex-col w-[50%] sm:w-[40%] lg:w-[30%] min-w-[250px] ${contact.alignment}`}
          >
            <label className="text-xl sm:text-2xl lg:text-4xl font-semibold lg:mb-4">
              {contact.name}
            </label>
            <label className="text-base sm:text-lg lg:text-2xl flex gap-3 lg:gap-4 lg:mb-3">
              <i className="bi bi-envelope-fill me-2 icon-style lg:text-3xl"></i>
              <a href={`mailto:${contact.email}`} className="hidden-link">
                {contact.email}
              </a>
            </label>
            <label className="text-base sm:text-lg lg:text-2xl flex gap-1 lg:gap-3">
              <i className="bi bi-telephone-fill me-2 icon-style lg:text-3xl"></i>
              <a href={`tel:${contact.phone}`} className="hidden-link">
                {contact.phone}
              </a>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminContacts;
